import { View, Text } from "@react-pdf/renderer";
import { styles, COLORS } from "./PdfStyles";

const CHECKMARK = "\u2713"; // ✓

/**
 * PdfCheckItem — renders a drawn checkbox + label.
 * Uses a View-drawn box instead of Unicode ☐/☑ (not supported by Inter font).
 *
 * Props:
 *   label   — text to display next to the checkbox
 *   checked — whether to show ✓ inside the box (true) or empty (false, default)
 */
export const PdfCheckItem = ({ label = "", checked = false, style, labelStyle }) => (
  <View
    style={[
      { flexDirection: "row", alignItems: "flex-start", marginBottom: 3 },
      style,
    ]}
  >
    {/* Drawn checkbox box */}
    <View
      style={{
        width: 10,
        height: 10,
        borderWidth: 1,
        borderColor: COLORS.text,
        marginRight: 3,
        marginTop: 1,
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {checked && (
        <Text style={{ fontSize: 8, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>
          {CHECKMARK}
        </Text>
      )}
    </View>
    <Text style={[styles.inlineRegular, { flex: 1 }, labelStyle]}>{label}</Text>
  </View>
);
